import { PromiseCardData } from '../types';

// Promise Cards Section Data
export const PROMISE_CARDS_DATA: PromiseCardData[] = [
  {
    id: 'taxsaving',
    title: 'Maximum tax<br class="md:hidden sm:hidden" /> savings',
    description:
      'Busineses save upto 2-7% of their net GST with us every month. Individuals can save upto ₹86,500 by filing their<br class="lg:hidden md:hidden sm:hidden"/> tax returns through us.',
    src: 'https://assets1.cleartax-cdn.com/cleartax/images/1605873617_taxsaving.svg',
    alt: 'taxsaving',
  },
  {
    id: 'unparalleled',
    title: 'Unparalleled <br class="md:hidden sm:hidden" />speed',
    description:
      'Experience 3x faster GST filings, 5x faster invoice reconciliation and 10x faster e-waybill generation. Individuals file their tax returns in under 3 min.',
    src: 'https://assets1.cleartax-cdn.com/cleartax/images/1605873731_unparalleled.svg',
    alt: 'unparalleled',
  },
  {
    id: 'fullcompliance',
    title: 'Accurate <br class="md:hidden sm:hidden" />Compliance',
    description:
      'Our products are designed and tested by in-house tax experts, ensuring every new clause, form or feature is updated and sent to you over the cloud.',
    src: 'https://assets1.cleartax-cdn.com/cleartax/images/1605873842_fullcompliance.svg',
    alt: 'fullcompliance',
  },
];
